function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import styles from './ChatInteractionPanel.module.scss';
import Logo from '../icons/logos/Nightbot';
import classNames from 'classnames';
import { Avatar, Text, Title } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
import { faReply, faUser } from '@fortawesome/free-solid-svg-icons';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import useIntlMemo from '@/hooks/useIntlMemo';
import { useDebounce } from 'use-debounce';
function NightbotReply(_param) {
    var interaction = _param.interaction, props = _object_without_properties(_param, [
        "interaction"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: styles.chatterContainer
    }, props), {
        children: /*#__PURE__*/ _jsxs(motion.div, {
            transition: {
                duration: 0.1
            },
            className: styles.chatter,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.logoContainer,
                    children: /*#__PURE__*/ _jsx(Logo, {
                        className: styles.logo
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.chatInteractionInfo,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            order: 4,
                            children: "Nightbot"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            size: "xs",
                            className: styles.message,
                            children: interaction.reply
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.chatterScanIcon,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        icon: faReply,
                        size: IconSizes.MD
                    })
                })
            ]
        })
    }));
}
function NightbotQuery(_param) {
    var interaction = _param.interaction, props = _object_without_properties(_param, [
        "interaction"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.chatterContainer)
    }, props), {
        children: /*#__PURE__*/ _jsxs(motion.div, {
            transition: {
                duration: 0.2
            },
            className: styles.chatter,
            exit: {
                opacity: 0
            },
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    radius: "md",
                    size: "sm",
                    color: "currentColor",
                    className: classNames(styles.chatterAvatar, interaction.avatarClassname),
                    children: /*#__PURE__*/ _jsx(Icon, {
                        icon: faUser,
                        size: IconSizes.MD
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.chatInteractionInfo,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            order: 4,
                            children: "Chatter"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            size: "xs",
                            className: styles.message,
                            children: interaction.query
                        })
                    ]
                })
            ]
        })
    }));
}
var INTERVAL = 2500; // 2.5 seconds
export default function ChatInteractionPanel(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var _React_useState = _sliced_to_array(React.useState(false), 2), showReply = _React_useState[0], setShowReply = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(0), 2), interactionCount = _React_useState1[0], setInteractionCount = _React_useState1[1];
    var ref = useRef(null);
    var inView = useInView(ref);
    var _useDebounce = _sliced_to_array(useDebounce(inView, 500), 1), debouncedInView = _useDebounce[0];
    var _React_useState2 = _sliced_to_array(React.useState(false), 2), isVisible = _React_useState2[0], setIsVisible = _React_useState2[1];
    var nightbotInteractions = useIntlMemo(function(intl) {
        return [
            {
                query: intl.formatMessage({
                    id: "r+mv2V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!uptime"
                        }
                    ]
                }),
                reply: intl.formatMessage({
                    id: "l0P5Po",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Stream has been live for 4 hours!"
                        }
                    ]
                }),
                avatarClassname: styles.avatarColorGreen
            },
            {
                query: intl.formatMessage({
                    id: "WFGMZK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!discord"
                        }
                    ]
                }),
                reply: intl.formatMessage({
                    id: "NAJgnz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Join our Discord! discord.com/invite/nightdev"
                        }
                    ]
                }),
                avatarClassname: styles.avatarColorPurple
            },
            {
                query: intl.formatMessage({
                    id: "5YldCo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!shoutout "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "@Platypuss"
                                }
                            ],
                            type: 8,
                            value: "b"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                reply: intl.formatMessage({
                    id: "w5l0Mf",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Check out "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "@Platypuss!"
                                }
                            ],
                            type: 8,
                            value: "b"
                        },
                        {
                            type: 0,
                            value: " twitch.tv/platypuss"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                avatarClassname: styles.avatarColorRed
            },
            {
                query: intl.formatMessage({
                    id: "PsGuu7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!song"
                        }
                    ]
                }),
                reply: intl.formatMessage({
                    id: "CD32Bs",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Current song playing is "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "PSY, Gangnam Style"
                                }
                            ],
                            type: 8,
                            value: "b"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                avatarClassname: styles.avatarColorYellow
            },
            {
                query: intl.formatMessage({
                    id: "N8nsc9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!hug "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "@Glowey"
                                }
                            ],
                            type: 8,
                            value: "b"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                reply: intl.formatMessage({
                    id: "Ez5Un9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Nightbot hugs "
                        },
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "@Glowey"
                                }
                            ],
                            type: 8,
                            value: "b"
                        },
                        {
                            type: 0,
                            value: "!"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                avatarClassname: styles.avatarColorGreen
            },
            {
                query: intl.formatMessage({
                    id: "+l161T",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "!winner"
                        }
                    ]
                }),
                reply: intl.formatMessage({
                    id: "tiZb/O",
                    defaultMessage: [
                        {
                            children: [
                                {
                                    type: 0,
                                    value: "@Sauce"
                                }
                            ],
                            type: 8,
                            value: "b"
                        },
                        {
                            type: 0,
                            value: " was randomly selected as the winner!"
                        }
                    ]
                }, {
                    b: function(chunks) {
                        return /*#__PURE__*/ _jsx("b", {
                            children: chunks
                        });
                    }
                }),
                avatarClassname: styles.avatarColorPink
            }
        ];
    }, []);
    var currentInteraction = React.useMemo(function() {
        var index = interactionCount % nightbotInteractions.length;
        return nightbotInteractions[index];
    }, [
        interactionCount,
        nightbotInteractions
    ]);
    React.useEffect(function() {
        if (!debouncedInView || !isVisible) {
            return;
        }
        setShowReply(function(prev) {
            return !prev;
        });
        var interval = setInterval(function() {
            return setShowReply(function(prev) {
                return !prev;
            });
        }, INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, [
        debouncedInView,
        isVisible
    ]);
    React.useEffect(function() {
        var handleVisibilityChange = function() {
            return setIsVisible(document.visibilityState === 'visible');
        };
        handleVisibilityChange();
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function() {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        className: classNames(styles.chatInteractionPanel, className)
    }, props), {
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "wait",
            initial: false,
            children: !showReply ? /*#__PURE__*/ _jsx(motion.div, {
                style: {
                    position: 'absolute',
                    width: '100%'
                },
                transition: {
                    ease: 'easeIn',
                    duration: 0.5,
                    type: 'spring',
                    stiffness: 130,
                    damping: 20
                },
                initial: {
                    opacity: 0,
                    y: 10
                },
                animate: {
                    opacity: 1,
                    y: 0,
                    scale: 1
                },
                exit: {
                    scale: 0.98,
                    transition: {
                        ease: 'easeOut'
                    }
                },
                children: /*#__PURE__*/ _jsx(NightbotQuery, {
                    interaction: currentInteraction
                })
            }, "nightbot-query") : /*#__PURE__*/ _jsx(motion.div, {
                style: {
                    position: 'absolute',
                    width: '100%'
                },
                transition: {
                    ease: 'easeOut',
                    duration: 0.5,
                    type: 'spring',
                    stiffness: 130,
                    damping: 20
                },
                initial: {
                    scale: 0.98,
                    transition: {
                        ease: 'easeIn'
                    }
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                exit: {
                    opacity: 0,
                    y: -10
                },
                onAnimationComplete: function(param) {
                    var id = param.id;
                    if (id === 'exit') {
                        setInteractionCount(function(prev) {
                            return prev + 1;
                        });
                    }
                },
                children: /*#__PURE__*/ _jsx(NightbotReply, {
                    interaction: currentInteraction
                })
            }, "nightbot-reply")
        })
    }));
}
